<button *ngIf="product" type="button" class="guest-row"
    [class.mobile]="view.Mobile"
    [class.dimmed]="!product.IsAvailable"
    [class.preselect]="IsPreselect"
    uppDataid="guestrow-product"
    (click)="OnSelect()">

    <div class="guest-row-media" *ngIf="DisplayProduct?.HasPhoto">
        <img class="guest-row-photo"
            [src]="DisplayProduct?.photo"
            alt=""
            loading="lazy"
            decoding="async"
            width="40"
            height="40" />
    </div>

    <div class="guest-row-text">
        <div class="guest-row-name" uppDataid="guestrow-name">{{tr(product.name)}}</div>

        <div class="guest-row-description" *ngIf="product.description as description">
            {{tr(description)}}
        </div>
    </div>

    <div class="guest-row-meta">
        <div class="guest-row-price" *ngIf="product.IsMarket">
            {{tr('@place_product_marketprice_brief')}}
        </div>

        <div class="guest-row-price" *ngIf="!product.IsMarket && RowPrice as price">
            <span class="starting" *ngIf="!product.IsAbleToCart">{{tr('@place_price_starting_from')}}</span>
            {{price.int}}<span class="decimal">,{{price.dec}}{{tr('@currency')}}</span><span class="unit" *ngIf="product.IsWeighted">/{{tr('@kilograms')}}</span>
        </div>

        <div class="guest-row-badge" [class.add]="InCartAmount === 0">
            <ion-icon *ngIf="InCartAmount === 0" name="add-outline"></ion-icon>
            <span *ngIf="InCartAmount > 0">{{InCartAmount}}</span>
        </div>
    </div>
</button>
